import React from 'react'
import ReactDOM from 'react-dom/client'
import {BrowserRouter} from 'react-router-dom'
import {ConfigProvider} from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import '@/assets/styles/index.less'
import {UserInfoProvider} from '@/store/userInfo'
import RouterEnter from '@/router/RouterEnter'
import Router from '@/router'
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

if (process.env.REACT_APP_ENV === 'mock') {
    require('./mock')
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <ConfigProvider locale={zhCN}>
        <UserInfoProvider>
            <BrowserRouter>
                <RouterEnter>
                    <Router/>
                </RouterEnter>
            </BrowserRouter>
        </UserInfoProvider>
    </ConfigProvider>
    // </React.StrictMode>
);
